Librarian.Modules.RecentEvents = new Class({
    Extends: Librarian.Modules.Module,
    Binds: ["onEventsLoaded"],

    options: {
        classPrefix: "modules-recentevents-",
        eventType: Librarian.eventType.oneOff,
        orderBy: "ExecTime",
        order: "desc",
        count: 10,
        showDate: true,
        dateFormat: "%m/%d/%Y"
    },

    initialize: function(options, wrapperEl) {
        this.setOptions(options);
        this.parent(this.options, wrapperEl);
    },

    load: function() {
        if (!this.wrapperEl)
            return;

        this.parent();

        this.request = Librarian.Events.getArchivedUserEvents(this.options.eventType, this.options.count, this.options.orderBy, this.options.order, "ujson", this.onEventsLoaded);
    },

    onEventsLoaded: function(json) {
        if (!json)
            return;

        this.containerEl.empty();

        var listEl = new Element("ul").injectInside(this.containerEl);

        for (var i = 0; i < json.length; i++) {
            var event = json[i],
                date = Librarian.Utils.extractDateFromString(event.ExecTime).format(this.options.dateFormat);

            // Create the list item and link for this file
            var listItemEl = new Element("li", {
                "class": (this.options.classPrefix || '') + "item"
            }).injectInside(listEl),
                linkEl = new Element("a", {
                    "class": (this.options.classPrefix || '') + "link",
                    "text": this.options.showDate ? (date + " - " + event.Name) : event.Name,
                    "title": event.Name,
                    "href": "javascript:void(0)",
                    "target": "_download"
                }).injectInside(listItemEl);

            linkEl.data = Object.toLowerKeys(event);
            linkEl.addOnClick(function() {
                var managerWindow = new Librarian.EventManagerWindow();
                managerWindow.show();

                if (this.data.eventid > 0) {
                    var detailWindow = new Librarian.EventDetailsWindow({
                        eventId: this.data.eventid,
                        grid: managerWindow.grid
                    });
                    detailWindow.show();
                }

                return false;
            });
        }
    }
});